import React, { Component } from 'react';
import styled from 'styled-components';
import { Formik, Field } from 'formik';
import InputField from '../../components/InputField';
import Button from '../../components/Button';
import * as Yup from 'yup';
import { user } from '../../consts/MOCK_DATA';
import { devices } from '../../styles/breakpoints';

const FieldContainer = styled.div`
  margin-bottom: 28px;
`;

const ActionContainer = styled.div`
  position: fixed;
  bottom: 0px;
  width: calc(100% - 32px);
  left: 0px;
  margin-left: 16px;

  @media ${devices.desktop} {
    position: relative;
  }
`;

const Form = styled.form`
  @media ${devices.desktop} {
    width: 368px;
    margin-top: 32px;
  }
`;

export default class SearchReservationForm extends Component {
  _getValidations = () => {
    return Yup.object().shape({
      reservationCode: Yup.string().required(),
      lastName: Yup.string().required()
    });
  };

  _onSubmit = values => {
    const { history } = this.props;
    /*
        ~ TODO ~
        MAKE REQUEST
        PASS USER TO ROUTE
    */
    history.push('u/flight-introduction', {
      user
    });
  };
  render() {
    return (
      <Formik
        initialValues={{
          reservationCode: '',
          lastName: ''
        }}
        onSubmit={this._onSubmit}
        validationSchema={this._getValidations}
        validateOnMount
      >
        {({ resetForm, values, handleSubmit, isValid }) => {
          return (
            <Form
              onSubmit={e => {
                e.stopPropagation();
                e.preventDefault();
                handleSubmit();
              }}
            >
              <FieldContainer>
                <Field
                  name="reservationCode"
                  label="Código da Reserva"
                  placeholder="Digite o código"
                  type="text"
                  component={InputField}
                  errorMessage="Campo obrigatório"
                  isRequired={true}
                  format={value => value}
                  parse={value => value}
                  onChange={value => value}
                  onBlur={value => value}
                />
              </FieldContainer>
              <FieldContainer>
                <Field
                  name="lastName"
                  label="Último nome"
                  placeholder="Digite o sobrenome"
                  type="text"
                  component={InputField}
                  errorMessage="Campo obrigatório"
                  isRequired={true}
                  format={value => value}
                  parse={value => value}
                  onChange={value => value}
                  onBlur={value => value}
                />
              </FieldContainer>
              <ActionContainer>
                <Button type="submit" success disabled={!isValid}>
                  Buscar Reserva
                </Button>
              </ActionContainer>
            </Form>
          );
        }}
      </Formik>
    );
  }
}
